import { CaseStudyPostTypes, LanguageTypes, OfferPostTypes, RegularPostTypes, ResourcePostTypes } from 'types/global';

export interface SiteConfig {
  languages: LanguageTypes[];
  blogCategories: RegularPostTypes[];
  specialBlogCategories: (ResourcePostTypes | CaseStudyPostTypes | OfferPostTypes)[];
  allCategories: string;
  menu: {
    defaultRouteSlug: string;
  };
  disableCookieBar?: boolean;
}

const BLOG_CATEGORIES: RegularPostTypes[] = [
  'automation',
  'automatyzacja',
  'business',
  'crowd_testing',
  'e-commerce',
  'future',
  'it',
  'guide',
  'uncategorized',
  'performance',
  'qa',
  'security',
  'ux',
  'news',
  'testarmy',
  'testarmy-pl',
  'nowoczesne-technologie',
];

const SPECIAL_BLOG_CATEGORIES: (ResourcePostTypes | CaseStudyPostTypes | OfferPostTypes)[] = ['ebook', 'webinar', 'case_study', 'offer'];

const config: SiteConfig = {
  languages: ['pl', 'en', 'de'],
  blogCategories: BLOG_CATEGORIES,
  specialBlogCategories: SPECIAL_BLOG_CATEGORIES,
  allCategories: BLOG_CATEGORIES.join(','),
  menu: {
    defaultRouteSlug: 'main',
  },
  disableCookieBar: true,
};

export default config;
